module.exports = __webpack_public_path__ + "img/kantine_3.276f6a8c.jpg";